import React, { useState } from "react";
import styled from "styled-components";
import { FaCheck, FaBan } from "react-icons/fa";
import { toast } from "react-toastify";
import api from "../api";

const TableWrapper = styled.div`
  width: 100%;
  overflow-x: auto;
  background-color: #fff;
  border-radius: 10px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  min-width: 280px;
`;

export const Thead = styled.thead`
  background-color: #1a5276;
  color: white;
`;
export const Tbody = styled.tbody``;
export const Tr = styled.tr`
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
`;

export const Th = styled.th`
  text-align: start;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;

  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
  }
`;

export const Td = styled.td`
  padding: 10px 12px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};
  width: ${(props) => (props.width ? props.width : "auto")};
  font-size: 14px;

  @media (max-width: 500px) {
    ${(props) => props.onlyWeb && "display: none"}
    padding: 8px 8px;
    font-size: 13px;
  }
`;

const PtsCell = styled.td`
  padding: 10px 12px;
  text-align: center;
  font-size: 14px;
  font-weight: 700;
  color: ${(props) => (props.valor > 0 ? "#1e8449" : "#666")};

  @media (max-width: 500px) {
    padding: 8px 8px;
    font-size: 13px;
  }
`;

export function adicionaZero(numero) {
  if (numero <= 9)
    return "0" + numero;
  else
    return numero;
}

export function DataHora(data) {
  const dt = new Date(data);
  return dt.toLocaleString("pt-BR", {
    timeZone: "America/Sao_Paulo",
    day: "2-digit", month: "2-digit", year: "2-digit",
    hour: "2-digit", minute: "2-digit"
  });
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

const ModalContent = styled.div`
  background-color: #fff;
  padding: 24px;
  border-radius: 12px;
  width: 100%;
  max-width: 340px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
`;

const ModalTitle = styled.h3`
  margin-bottom: 12px;
  font-size: 16px;
`;

const ModalInput = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  margin-bottom: 14px;
`;

const ModalBtnRow = styled.div`
  display: flex;
  gap: 8px;
`;

const BtnConfirmar = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #27ae60;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
`;

const BtnCancelar = styled.button`
  flex: 1;
  padding: 10px;
  background-color: #95a5a6;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
`;

const Grid = ({ users, setUsers, user = null }) => {
  const [modalAberto, setModalAberto] = useState(false);
  const [senha, setSenha] = useState("");
  const [usuarioSelecionado, setUsuarioSelecionado] = useState(null);

  // Mostra coluna de pontos: se mercado fechou OU se algum time já tem pontuação (parciais)
  const mostraPts = users.length > 0 && (
    new Date(users[0]?.fimRodada) <= new Date() ||
    users.some(u => u.pontuacao > 0)
  );

  const confirmarDireto = (item) => {
    const novaConfirmacao = !item.confirmado;
    api.post("liga/confirmaTimeRodada/", {
      idTimeRodada: item.idTimeRodada,
      confirmar: novaConfirmacao,
    })
      .then(({ data }) => {
        setUsers(item.idRodada);
        const valorRodada = item.valorRodada;
        const novoSaldo = item.creditos + (novaConfirmacao ? -valorRodada : +valorRodada);
        const negativo = novoSaldo < 0;
        toast.success(
          negativo ? (
            <><span style={{ color: "red", fontWeight: "bold" }}>SEU SALDO ESTÁ NEGATIVO</span><br />Saldo {valorReais(novoSaldo)}<br />Status atualizado!</>
          ) : (
            <>Saldo {valorReais(novoSaldo)}<br />Status atualizado!</>
          )
        );
      })
      .catch((error) => {
        toast.error(error.response?.data?.message || "Erro ao atualizar status!");
      });
  };

  const abrirModal = (usuario) => {
    if (new Date(users[0]?.fimRodada) <= new Date()) {
      alert("Não é possível alterar, o mercado está fechado.");
    } else if (user && user.id === usuario.idUsuario) {
      confirmarDireto(usuario);
    } else {
      setUsuarioSelecionado(usuario);
      setSenha("");
      setModalAberto(true);
    }
  };

  function valorReais(valor) {
    return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(valor ?? 0);
  }

  const confirmarSenha = (item) => {
    if (senha === item.senha) {
      const novaConfirmacao = !item.confirmado;

      api.post("liga/confirmaTimeRodada/", {
        idTimeRodada: item.idTimeRodada,
        confirmar: novaConfirmacao,
      })
        .then(({ data }) => {
          setUsers(item.idRodada);
          setModalAberto(false);

          const valorRodada = usuarioSelecionado.valorRodada;
          const novoSaldo = usuarioSelecionado?.creditos + (novaConfirmacao ? -valorRodada : +valorRodada);
          const negativo = novoSaldo < 0;

          toast.success(
            negativo ? (
              <>
                <span style={{ color: "red", fontWeight: "bold" }}>SEU SALDO ESTÁ NEGATIVO</span>
                <br />
                Saldo {valorReais(novoSaldo)}
                <br />
                Status atualizado!
              </>
            ) : (
              <>
                Saldo {valorReais(novoSaldo)}
                <br />
                Status atualizado!
              </>
            )
          );
        })
        .catch((error) => {
          toast.error(error.response?.data?.message || "Erro ao atualizar status!");
        });
    } else {
      toast.error("Senha incorreta!");
    }
  };

  return (
    <>
      <TableWrapper>
        <Table>
          <Thead>
            <Tr>
              <Th>Cartoleiro</Th>
              <Th onlyWeb>Time</Th>
              {mostraPts && <Th style={{ textAlign: "center" }}>Pts</Th>}
              <Th style={{ textAlign: "center" }}>✔</Th>
            </Tr>
          </Thead>
          <Tbody>
            {users.map((item, i) => (
              <Tr key={i}>
                <Td>{item.cartoleiro}</Td>
                <Td onlyWeb>{item.nomeTime}</Td>
                {mostraPts && (
                  <PtsCell valor={item.pontuacao}>
                    {item.pontuacao > 0 ? Number(item.pontuacao).toFixed(2) : "–"}
                  </PtsCell>
                )}
                <Td alignCenter>
                  {item.confirmado ? (
                    <FaCheck
                      color="#27ae60"
                      style={{ cursor: "pointer" }}
                      onClick={() => abrirModal(item)}
                    />
                  ) : (
                    <FaBan
                      color="#e74c3c"
                      style={{ cursor: "pointer" }}
                      onClick={() => abrirModal(item)}
                    />
                  )}
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableWrapper>

      {modalAberto && (
        <ModalOverlay>
          <ModalContent>
            <ModalTitle>Confirmar participação</ModalTitle>
            <p style={{ fontSize: 14, marginBottom: 12 }}>
              Digite a senha de <strong>{usuarioSelecionado?.cartoleiro}</strong>:
            </p>
            <ModalInput
              type="password"
              value={senha}
              onChange={(e) => setSenha(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && confirmarSenha(usuarioSelecionado)}
              autoFocus
            />
            <ModalBtnRow>
              <BtnConfirmar onClick={() => confirmarSenha(usuarioSelecionado)}>
                Confirmar
              </BtnConfirmar>
              <BtnCancelar onClick={() => setModalAberto(false)}>
                Cancelar
              </BtnCancelar>
            </ModalBtnRow>
          </ModalContent>
        </ModalOverlay>
      )}
    </>
  );
};

export default Grid;

